import { translateText } from '@/locales/text'
export default {
  get '401' () { return translateText('认证失败，无法访问系统资源') },
  get '403' () { return translateText('当前操作没有权限') },
  get '404' () { return translateText('访问资源不存在') },
  get 'default' () { return translateText('系统未知错误，请反馈给管理员') }
}
